import {
  useAPIKinerja,
  useAPIPelaksanaanProgress,
} from 'api/kinerja/useAPIKinerja'

import type { KinerjaRoleType } from 'types/kinerja'

export default function usePelaksanaan(
  enabled: boolean,
  params: { role?: KinerjaRoleType } = {}
) {
  const {
    data,
    isFetched: isPerencanaanFetched,
    refetch: refetchSKP,
  } = useAPIKinerja(
    {
      enabled,
    },
    params
  )
  const {
    data: dataPelaksanaan,
    isLoading: isLoadingPelaksanaan,
    isError,
  } = useAPIPelaksanaanProgress({
    opts: {
      useErrorBoundary: false,
      enabled: isPerencanaanFetched && data?.data?.status === 'READY',
      retry: 5,
      retryDelay: 750,
    },
  })

  return {
    refetchSKP,
    dataPerencanaan: data,
    dataPelaksanaan,
    isErrorPelaksanaan: isError,
    isLoadingPelaksanaan,
    isPerencanaanFetched,
  }
}
